import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { getBrandSupport } from '@utils/get-brand-support.ts';

import { EmailHelpIcon, PhoneHelpIcon, TelegramIcon } from '@shared/components/icons';

import * as Styled from './help.styled';

type OwnProps = {
	goBack: () => void;
};

const Help: React.FC<OwnProps> = ({ goBack }) => {
	const { t } = useTranslation(['faq', 'help']);

	const supportData = getBrandSupport();

	return (
		<Styled.Wrapper>
			<Styled.HelpTitle>
				{t('help:have_trouble')}
				<br />
				{t('help:ask_help')}
			</Styled.HelpTitle>
			<Styled.HelpButtonWrapper>
				{supportData.tg && (
					<Link to={`https://t.me/${supportData.tg}`} target='_blank'>
						<Styled.HelpButtonMain $type='telegram'>
							<TelegramIcon />@{supportData.tg}
						</Styled.HelpButtonMain>
					</Link>
				)}
				{supportData.phone && (
					<Link to={`tel:${supportData.phone}`} target='_blank'>
						<Styled.HelpButtonMain $type='phone'>
							<PhoneHelpIcon />
							{supportData.phoneText}
						</Styled.HelpButtonMain>
					</Link>
				)}
				{supportData.mail && (
					<Link to={`mailto:${supportData.mail}`} target='_blank'>
						<Styled.HelpButtonMain $type='email'>
							<EmailHelpIcon />
							{supportData.mail}
						</Styled.HelpButtonMain>
					</Link>
				)}
			</Styled.HelpButtonWrapper>
			<Styled.HelpButton onClick={goBack}>{t('back')}</Styled.HelpButton>
		</Styled.Wrapper>
	);
};

export default React.memo(Help);
